import axios from 'axios';

const getSettings = callback => {
  const payload = {
    regulations: false,
    settings: false,
    data: {},
  };

  const metaTag = document.querySelector(`meta[name="eager-data"]`);
  if (metaTag) {
    callback ({data: JSON.parse(metaTag.getAttribute('content'))});
    return;
  }

  axios({
    method: 'get',
    url: '/maxmortgage/regulations',
  })
    .then(response => {
      payload.data = { ...payload.data, regulations: response.data };
      payload.regulations = true;
      if (payload.settings && payload.providers) callback(payload);
    })
    .catch(err => console.error(err));

  axios({
    method: 'get',
    url: '/maxmortgage/tool-settings',
  })
    .then(response => {
      payload.data = { ...payload.data, ...response.data };
      payload.settings = true;

      callback(payload);
    })
    .catch(err => console.error(err));
};

const sortFrtResults = (a, b) => {
  if (a.maximum_mortgage === b.maximum_mortgage) {
    return a.interest_rate > b.interestRate ? -1 : 1;
  }

  return a.maximum_mortgage < b.maximum_mortgage ? 1 : -1;
};

export { getSettings, sortFrtResults };
